module.exports = __webpack_public_path__ + "img/entreprise-boas.677363ff.jpg";